function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  cursor: pointer;\n  outline: none;\n  transition: all 0.2s ease-in-out;\n  background: transparent;\n  font-weight: 500;\n  \n  flex: 1;\n  padding: 0.75rem 0;\n  border-radius: 0;\n  box-shadow: none;\n  \n  color: ",
        ";\n  \n  border-bottom: ",
        ";\n  \n  &:hover {\n    color: ",
        ";\n    background-color: transparent;\n  }\n  \n  &:active {\n    transform: scale(0.98);\n  }\n  \n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React from 'react';
import styled from '@emotion/styled';
var StyledTabButton = styled.button(_templateObject(), function(props) {
    var _props_theme, _props_theme1;
    return props.isActive ? ((_props_theme = props.theme) === null || _props_theme === void 0 ? void 0 : _props_theme.primary) || 'var(--theme-primary)' : ((_props_theme1 = props.theme) === null || _props_theme1 === void 0 ? void 0 : _props_theme1.textSecondary) || 'var(--theme-text-secondary)';
}, function(props) {
    var _props_theme;
    return props.isActive ? "2px solid ".concat(((_props_theme = props.theme) === null || _props_theme === void 0 ? void 0 : _props_theme.primary) || 'var(--theme-primary)') : 'none';
}, function(props) {
    var _props_theme, _props_theme1;
    return props.isActive ? ((_props_theme = props.theme) === null || _props_theme === void 0 ? void 0 : _props_theme.primary) || 'var(--theme-primary)' : ((_props_theme1 = props.theme) === null || _props_theme1 === void 0 ? void 0 : _props_theme1.text) || 'var(--theme-text)';
});
/**
 * TabButton 컴포넌트 - 탭 네비게이션에 사용되는 버튼입니다.
 * 
 * 아토믹 디자인의 분자(Molecule) 레벨 컴포넌트
 */ var TabButton = function(param) {
    var label = param.label, icon = param.icon, isActive = param.isActive, onClick = param.onClick, _param_className = param.className, className = _param_className === void 0 ? '' : _param_className;
    return /*#__PURE__*/ React.createElement(StyledTabButton, {
        isActive: isActive,
        onClick: onClick,
        className: className
    }, icon && /*#__PURE__*/ React.createElement("span", {
        style: {
            marginRight: '0.5rem'
        }
    }, icon), label);
};
export default TabButton;
